import { render, staticRenderFns } from "./companySwitch.vue?vue&type=template&id=85862a7e&scoped=true&"
import script from "./companySwitch.vue?vue&type=script&lang=js&"
export * from "./companySwitch.vue?vue&type=script&lang=js&"
import style0 from "./companySwitch.vue?vue&type=style&index=0&id=85862a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85862a7e",
  null
  
)

export default component.exports